var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tooltip',{attrs:{"content":_vm.content,"placement":"top","max-width":"400","transfer":""}},[_c('Icon',{attrs:{"type":"md-help-circle","size":"16"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }